import React from "react";
import { Result, Button } from "antd";
import { StopOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { AuthContext } from "../../../services/auth.service";

function CompanyDeactivated() {
    const { companyInfo } = useContext(AuthContext);

    return (
    <div className="dashboard-tabs-container">
        <Result
          icon={<StopOutlined style={{ color: "#ff4d4f" }} />}
          title="Company Deactivated"
          subTitle={
            <>
              The company "{companyInfo?.name || "Unknown"}" has been
              deactivated or no longer exists. If you believe this is an error, please contact support.
              <br />
              If you have access to other companies, you can switch using the
              dropdown in the sidebar.
            </>
          }
          extra={
            <Button type="primary" href="/support_request">
              Contact Support
            </Button>
          }
        />
      </div>
    )
}

export default CompanyDeactivated;